import { render } from "./TableListKapal.vue?vue&type=template&id=675e1a23"
import script from "./TableListKapal.vue?vue&type=script&lang=js"
export * from "./TableListKapal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__